import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './WrapperLk.module.scss';

export const WrapperLk = ({
  children,
  IsMobile,
  className,
  onClick,
}: {
  children: ReactNode;
  IsMobile?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <div onClick={onClick} className={classNames(styles.Wrapper, { [styles.IsMobile]: IsMobile }, className)}>
      {children}
    </div>
  );
};
